import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class DateSelectionService {
  private currentEditingDateIndex: number | null = null;

  setCurrentEditingDate(index: number | null): void {
    this.currentEditingDateIndex = index;
  }

  getCurrentEditingDate(): number | null {
    return this.currentEditingDateIndex;
  }
}


